import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import Fab from "@mui/material/Fab";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import SelectBoxSearch from "src/shared/components/select_box_search";
import { Requirement, RequirementFromExcel, Task } from "../../interface";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { tableStyles } from "src/shared/util/tableStyles";

export const Requirements = ({
    task,
    listForConfig,
    onChange,
    listOfLocationForProject,
}: {
    task: Task | undefined;
    listForConfig: any;
    onChange: any;
    listOfLocationForProject: any[];
}) => {
    const options: string[] = ["all"];

    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [inputValueFilter, setInputValueFilter] = useState<string>("");

    const [requirements, setRequirements] = useState<Requirement[]>([]);

    const [showAddOptions, setShowAddOptions] = useState(false);

    useEffect(() => {
        let requirements: Requirement[] = task?.requirements || [];

        if (inputValueFilter !== "") {
            requirements = requirements.filter((requirement) => {
                const locationFilter = requirement.locationName
                    .toLowerCase()
                    .includes(inputValueFilter.toLowerCase());

                const requirementFilter = requirement.requirementName
                    .toLowerCase()
                    .includes(inputValueFilter.toLowerCase());

                const requireByFilter = requirement.requiredBy
                    .toLowerCase()
                    .includes(inputValueFilter.toLowerCase());

                if (locationFilter || requirementFilter || requireByFilter) {
                    return true;
                }
            });
        }

        setRequirements(requirements);
    }, [task, inputValueFilter]);

    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOption(event.target.value);
        setInputValueFilter("");
    };

    const handleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValueFilter(event.target.value);
    };

    const handlePasteRequirement = () => {
        if (listOfLocationForProject.length === 0) {
            alert(
                "No hay Pozos para agregar requerimientos, favor seleccionar un proyecto"
            );
        }

        const jsonData: RequirementFromExcel[] = [];

        navigator.clipboard
            .readText()
            .then((text) => {
                try {
                    const rows = text
                        .split("\n")
                        .filter((row) => row.trim() !== "");
                    rows.forEach((row) => {
                        if (row.split("\t").length < 5) {
                            alert("El formato de los datos no es correcto");
                        }

                        if (row.split("\t")[0].includes("Locacion")) {
                            return;
                        }

                        const [
                            optimizationActivityId,
                            locationId,
                            Locacion,
                            requeridoPor,
                            nivel,
                            carta,
                            reespaceo,
                            pv,
                            pp,
                            muestras,
                        ] = row.split("\t");

                        jsonData.push({
                            optimizationActivityId,
                            locationId,
                            Locacion,
                            requeridoPor,
                            Nivel: nivel,
                            Carta: carta,
                            Reespaceo: reespaceo,
                            "Prueba de Válvula": pv,
                            "Prueba Presión": pp,
                            Muestras: muestras,
                        });
                    });
                } catch (error) {
                    console.error("Error parsing clipboard data", error);
                }
            })
            .then(() => {
                const sortRequirements: Requirement[] = [];
                const locationNoFound: string[] = [];

                jsonData.forEach((requirement: any) => {
                    const location = listOfLocationForProject.find(
                        (location) => location.name === requirement.Locacion
                    );
                    if (location) {
                        [
                            "Nivel",
                            "Carta",
                            "Reespaceo",
                            "Prueba de Válvula",
                            "Prueba Presión",
                            "Muestras",
                        ].forEach((requirementName) => {
                            const value = requirement[requirementName]
                                ?.trim()
                                .toLowerCase();

                            if (value === "si") {
                                sortRequirements.push({
                                    optimizationActivityId:
                                        requirement.optimizationActivityId,
                                    locationName: location.name,
                                    requirementName: requirementName,
                                    requiredBy: requirement.requeridoPor,
                                    requiredDate: requirement.fechaRequerido,
                                    comments: "",
                                    executed: false,
                                    value: true,
                                });
                            }
                        });

                        const existRequiremntForLocation = sortRequirements.find(
                            (req) =>
                                req.locationName === location.name 
                        );

                        if(!existRequiremntForLocation){
                            sortRequirements.push({
                                optimizationActivityId:
                                    requirement.optimizationActivityId,
                                locationName: location.name,
                                requirementName: "Visita",
                                requiredBy: requirement.requeridoPor,
                                requiredDate: requirement.fechaRequerido,
                                comments: "",
                                executed: false,
                                value: false,
                            });
                        }

                    } else {
                        locationNoFound.push(requirement.Locacion);
                    }
                });

                if (sortRequirements.length === 0) {
                    alert(
                        "No se encontraron requerimientos que agregar a la tarea"
                    );
                } else if (locationNoFound.length > 0) {
                    alert(
                        `No se encontraron las siguientes locaciones: ${locationNoFound.join(
                            ", "
                        )}`
                    );
                }

                if (sortRequirements.length > 0) {
                    onChange(sortRequirements, "requirements");
                }
            });
    };

    const handleClearRequirements = () => {
        onChange([], "requirements");
    };

    const columns: GridColDef[] = [
        // { field: "id", headerName: "ID", flex: 0.1 },
        { field: "locationName", headerName: "Pozo", flex: 0.5 },
        { field: "requirementName", headerName: "Requerimiento", flex: 0.5 },
        { field: "requiredBy", headerName: "Requerido Por", flex: 0.5 },
        { field: "executed", headerName: "Ejecutado", flex: 0.5, type: 'boolean' },
        { field: "visited", headerName: "Visitado", flex: 0.5, type: 'boolean' },
        { field: "comments", headerName: "Comentario", flex: 1 }
    ]

    return (
        <Grid size={12}>
            <DataGrid
                rows={task?.requirements || []}
                columns={columns}
                pageSizeOptions={[10, 20, 50, 100]}
                checkboxSelection={false}
                sx={{
                    mt: 2,
                    height: {
                        md: `calc(100vh - 395px)`,
                        lg: `calc(100vh - 395px)`,
                        xl: `calc(100vh - 400px)`,
                    },
                    ...tableStyles,
                }}
                getRowId={(row) => `${row.locationName}-${row.requirementName}`}
            />
            <Box
                sx={{
                    "& > :not(style)": { m: 1 },
                    position: "absolute",
                    right: 16,
                    bottom: 26,
                }}
            >
                {showAddOptions ? (
                    <>
                        <Fab
                            size="small"
                            color="primary"
                            aria-label="add"
                            onClick={handleClearRequirements}
                        >
                            <DeleteForeverIcon />
                        </Fab>
                        <Fab
                            size="small"
                            color="primary"
                            aria-label="add"
                            onClick={handlePasteRequirement}
                        >
                            <ContentPasteGoIcon />
                        </Fab>
                        <Fab
                            size="small"
                            color="error"
                            aria-label="add"
                            onClick={() => setShowAddOptions(!showAddOptions)}
                        >
                            <CloseIcon />
                        </Fab>
                    </>
                ) : (
                    <Fab
                        size="small"
                        color="primary"
                        aria-label="add"
                        onClick={() => setShowAddOptions(!showAddOptions)}
                    >
                        <AddIcon />
                    </Fab>
                )}
            </Box>
        </Grid>
    );
};
